import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import getLanguage from 'utils/language';

import enTranslations from './locales/en/en.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';

import frTranslations from './locales/fr/fr.json';
import frHome from './locales/fr/home.json';
import frAbout from './locales/fr/about.json';

const resources = {
  en: {
    translation: enTranslations,
    home: enHome,
    about: enAbout,
  },
  fr: {
    translation: frTranslations,
    home: frHome,
    about: frAbout,
  },
};

export const DEFAULT_LANGUAGE = 'en';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguage(),
    fallbackLng: ['en', 'fr'],

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
